var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecHrInterview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1907 11.307C18.4665 11.0705 18.3177 10.6148 17.9569 10.5909L16.1332 10.4696C15.9783 10.4593 15.8432 10.3599 15.7858 10.2142L15.0976 8.46588C14.963 8.12411 14.4846 8.12411 14.35 8.46588L13.6618 10.2142C13.6044 10.3599 13.4693 10.4593 13.3144 10.4696L11.4929 10.5909C11.1323 10.6149 10.9834 11.0703 11.259 11.3068L12.662 12.5114C12.7792 12.612 12.8294 12.7713 12.7915 12.9219L12.3313 14.7482C12.2415 15.1047 12.6286 15.389 12.9361 15.1925L14.5088 14.1872C14.6401 14.1033 14.8075 14.1033 14.9387 14.1872L16.5115 15.1925C16.819 15.389 17.2061 15.1047 17.1163 14.7482L16.6562 12.9221C16.6182 12.7714 16.6685 12.612 16.7859 12.5114L18.1907 11.307Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08045 6.34902C4.08045 4.22326 5.78474 2.5 7.88707 2.5C9.98941 2.5 11.6937 4.22326 11.6937 6.34902C11.6937 8.47477 9.98941 10.198 7.88707 10.198C5.78474 10.198 4.08045 8.47477 4.08045 6.34902Z",
    fill: "#23242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 17.7384C1.66675 14.2648 4.45168 11.4488 7.88707 11.4488C8.21636 11.4488 8.53968 11.4747 8.85514 11.5246C8.92311 11.6647 9.01805 11.7921 9.13753 11.8978L11.1448 13.264L10.7425 15.7046C10.626 16.181 10.7425 16.6398 11.1818 16.9723C11.6564 17.3317 12.3551 17.1876 12.7539 16.9249L13.9487 16.3208C14.0525 16.7764 14.1074 17.251 14.1074 17.7384C14.1074 18.067 13.844 18.3333 13.5191 18.3333H2.25509C1.93016 18.3333 1.66675 18.067 1.66675 17.7384Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecHrInterview);
export default __webpack_public_path__ + "static/media/rec-hr-interview.9ed82746c1e03dbac1ee0556e58362e4.svg";
export { ForwardRef as ReactComponent };